<template>
  <FormContainer withoutDivider>
    <template #title>Détails du contrat</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_40"
          v-model="cdiInterimaireModel"
          label="En CDI intérimaire ?"
          :items="OuiOuNon"
          :required="meta.contrat?.cdiInterimaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.cdiInterimaire?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperInputDate
          v-if="meta.contrat?.dateConclusion?.$status === PropertyStatus.Required"
          id="field_41"
          v-model="dateConclusionModel"
          label="Date de conclusion du CDI intérimaire"
          :required="meta.contrat?.dateConclusion?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateConclusion?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDate
          v-else
          id="field_41"
          label="Date de conclusion du CDI intérimaire"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          disabled
        />
        <WrapperToggleSwitch
          v-if="meta.contrat?.tempsPlein?.$status === PropertyStatus.Required"
          id="field_42"
          v-model="tempsPleinModel"
          label="Temps plein"
          :items="OuiOuNon"
          :required="meta.contrat?.tempsPlein?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.tempsPlein?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperToggleSwitch
          v-else
          id="field_42"
          label="Temps plein"
          :items="OuiOuNon"
          class="col-10 col-md-14 col-sm-36"
          disabled
        />
      </div>

      <div class="form__bloc">
        <WrapperInputNumber
          id="field_43"
          v-model="dureePeriodeEssaiJoursModel"
          :decimal="0"
          label="Durée de la période d’essai (en jours calendaires)"
          :required="meta.contrat?.dureePeriodeEssaiJours?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dureePeriodeEssaiJours?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          deletable
          :readonly
        />
        <WrapperInputDuree
          v-if="meta.contrat?.dureeHebdomadaire?.$status === PropertyStatus.Required"
          id="field_44"
          v-model="dureeHebdomadaireModel"
          label="Durée hebdomadaire du travail"
          :required="meta.contrat?.dureeHebdomadaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dureeHebdomadaire?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DUREE"
          :hint="HINT_DUREE"
          deletable
          :readonly
        />
        <WrapperInputDuree
          v-else
          id="field_44"
          label="Durée hebdomadaire du travail"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DUREE"
          :hint="HINT_DUREE"
          disabled
        />
      </div>

      <div
        class="form__bloc"
        v-if="meta.contrat?.dateDebutContrat?.$status !== PropertyStatus.NotPresent"
      >
        <WrapperInputDate
          id="field_45"
          v-model="dateDebutContratModel"
          label="Date de début du contrat"
          :required="meta.contrat?.dateDebutContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateDebutContrat?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_46"
          v-model="dateFinContratModel"
          label="Date de fin du contrat"
          :required="meta.contrat?.dateFinContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateFinContrat?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
      </div>
      <div
        class="form__bloc"
        v-if="estDossier && meta.mission?.dateDebut?.$status !== PropertyStatus.NotPresent"
      >
        <WrapperInputDate
          id="field_100"
          v-model="dateDebutMissionModel"
          label="Date de début de mission"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="meta.mission?.dateDebut?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.dateDebut?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInputDate
          id="field_101"
          v-model="dateFinMissionModel"
          label="Date de fin de mission"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="meta.mission?.dateFin?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.dateFin?.$messageErreurDirty!"
          :readonly
        />
         <WrapperInputNumber
          id="field_99"
          v-model="dureeMissionModel"
          label="Durée de la mission"
          hint="Durée de la mission en heures"
          :required="meta.mission?.duree?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.duree?.$messageErreurDirty!"
          :decimal="0"
          deletable
          :readonly
          class="col-12 col-md-18 col-sm-36"
        />
      </div>

      <div class="form__bloc">
        <WrapperInputNumber
          id="field_47"
          v-model="salaireHoraireFormationModel"
          label="Salaire horaire brut non chargé du salarié en formation (€ / h)"
          :required="meta.contrat?.salaireHoraireFormation?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.salaireHoraireFormation?.$messageErreurDirty!"
          hint="€ / heure"
          class="col-12 col-md-14 col-sm-36"
          :separateur="true"
          :placeholder="PLACEHOLDER_MONTANT_HORAIRE"
          :readonly
          :maxlength="7"
          :decimal="2"
        />
        <WrapperInputNumber
          v-if="meta.contrat?.salaireHoraireMission?.$status !== PropertyStatus.NotPresent"
          id="field_48"
          v-model="salaireHoraireMissionModel"
          label="Salaire horaire brut non chargé du salarié en mission (€ / h)"
          :required="meta.contrat?.salaireHoraireMission?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.salaireHoraireMission?.$messageErreurDirty!"
          hint="€ / heure"
          class="col-12 col-md-14 col-sm-36"
          :separateur="true"
          :placeholder="PLACEHOLDER_MONTANT_HORAIRE"
          :readonly
          :maxlength="7"
          :decimal="2"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { DureeHebdomadaireDTO } from '@/features/api/extranet/dto/Demande/shared'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import {
  DEMANDE_STORE,
  FormContainer,
  HINT_DATE,
  HINT_DUREE,
  PLACEHOLDER_DATE,
  PLACEHOLDER_DUREE,
  PLACEHOLDER_MONTANT_HORAIRE,
} from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()

  const { setupFieldWithKey } = store
  const { meta, readonly, estDossier } = storeToRefs(store)

  const cdiInterimaireModel = setupFieldWithKey<string>('contrat.cdiInterimaire', false)
  const dateConclusionModel = setupFieldWithKey<string>('contrat.dateConclusion', false)
  const tempsPleinModel = setupFieldWithKey<string>('contrat.tempsPlein', false)

  const dureePeriodeEssaiJoursModel = setupFieldWithKey<number>('contrat.dureePeriodeEssaiJours', true)
  const dureeHebdomadaireModel = setupFieldWithKey<DureeHebdomadaireDTO>('contrat.dureeHebdomadaire', true)

  const dateDebutContratModel = setupFieldWithKey<string>('contrat.dateDebutContrat', true)
  const dateFinContratModel = setupFieldWithKey<string>('contrat.dateFinContrat', true)
  const salaireHoraireFormationModel = setupFieldWithKey<string>('contrat.salaireHoraireFormation', false)
  const salaireHoraireMissionModel = setupFieldWithKey<string>('contrat.salaireHoraireMission', false)

  const dateDebutMissionModel = setupFieldWithKey<string>('mission.dateDebut', true)
  const dateFinMissionModel = setupFieldWithKey<string>('mission.dateFin', true)

  const dureeMissionModel = setupFieldWithKey<number>('mission.duree', true)
</script>
